import PageLayout from '../../components/Page/layout';
import CategoriesTabs from '../../components/TemplatesPage/CategoriesTabs';
import TemplatePacks from '../../components/TemplatesPage/TemplatePacks';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { useEffect, useState } from 'react';
import {
  DocumentDuplicateIcon,
  FireIcon,
  HomeIcon,
  LightningBoltIcon,
  LockClosedIcon,
  StarIcon,
  XIcon,
} from '@heroicons/react/solid';
import UpgradePlanModal from '../../components/Plans/UpgradePlanModal';
import Button from '../../components/Button';

//import framer motion
import { motion } from 'framer-motion';
import {
  EssayIconColor,
  EssayIconSecondary,
} from '../../components/TemplatesPage/Icons';
import { getActivePlan } from '../../utils/helpers';
import LogInModal from '../../components/NewModals/log-in';

const proPlans = [
  'Premier',
  'premier',
  /*     "Hobby", */
  'Expert',
  'Pro',
  'pro',
  'Expert Lifetime',
];

export const getStaticProps = async () => {
  try {
    const firebaseConfig = {
      apiKey: 'AIzaSyA64Cm0bTMY9Rinvha_z3ENAUhkJssFCO8',
      authDomain: 'auth.typeshare.co',
      projectId: 'typeshare-2027d',
      storageBucket: 'typeshare-2027d.appspot.com',
      databaseURL: 'https://typeshare-2027d-default-rtdb.firebaseio.com/',
      messagingSenderId: '305996917305',
      appId: '1:305996917305:web:704a11e8f876840e87bbe8',
      measurementId: 'G-LX68JP4ZZK',
    };

    //TEST APP

    const firebaseConfigStaging = {
      apiKey: 'AIzaSyD5pDmQa1lIAYiW1qd7Swez2gaXG-ggWtc',
      authDomain: 'test-88a5a.firebaseapp.com',
      projectId: 'test-88a5a',
      storageBucket: 'test-88a5a.appspot.com',
      messagingSenderId: '952460692987',
      appId: '1:952460692987:web:0b0eb7f65c0e3f6767cf5e',
    };

    if (process.env.NEXT_PUBLIC_APP_ENV === 'production') {
      if (firebase.apps.length === 0) {
        firebase.initializeApp(firebaseConfig);
      }
    } else {
      if (firebase.apps.length === 0) {
        firebase.initializeApp(firebaseConfigStaging);
      }
    }

    const baseRef = firebase.database().ref('templates2');
    const packsRef = await baseRef.child('packs').child('packs').once('value');

    const editionsRef = await baseRef
      .child('packs')
      .child('editions')
      .once('value');

    const editionIDs = Object.keys(editionsRef.val());

    //for each edition, get the packIDs listed in edition.packs and get the pack data
    const editions = await Promise.all(
      editionIDs.map(async (editionID) => {
        const packIDs = Object.keys(editionsRef.val()[editionID].packs);
        var packs = await Promise.all(
          packIDs.map(async (packID) => {
            const packRef = await baseRef
              .child('packs')
              .child('packs')
              .child(packID)
              .once('value');
            return packRef.val();
          }),
        );

        //get creator's name and photo from firebase and update templates
        const creators = await Promise.all(
          packs.map(async (pack) => {
            const ref = baseRef.child('creators').child(pack.meta.creator);
            const snapshot = await ref.once('value');
            return snapshot.val();
          }),
        );

        packs.forEach((pack, index) => {
          pack.meta.creator_name = creators[index].name;
          pack.meta.creator_photo = creators[index].photo;
        });

        //order packs by meta.packNumber
        packs.sort((a, b) => {
          return a.meta.packNumber - b.meta.packNumber;
        });

        //return the packs and the edition metadata
        return {
          packs,
          edition: editionsRef.val()[editionID].meta,
          price: editionsRef.val()[editionID].price
            ? editionsRef.val()[editionID].price
            : null,
        };
      }),
    );

    //order editions by meta.order
    editions.sort((a, b) => {
      return a.edition.order - b.edition.order;
    });

    const STRIPE_PK = process.env.STRIPE_PK;

    return {
      props: {
        exists: true,
        editions: editions,
        STRIPE_PK: process.env.STRIPE_PK,
      },
      revalidate: 1,
    };
  } catch (error) {
    return {
      props: {
        exists: false,
        STRIPE_PK: process.env.STRIPE_PK,
      },
      revalidate: 1,
    };
  }
};

export default function TemplatesPage({ editions, STRIPE_PK }) {
  const [unlockedPacks, setUnlockedPacks] = useState(null);
  const [userID, setUserID] = useState(null);
  const [productName, setProductName] = useState('Free Plan');

  const [onboarding, setOnboarding] = useState(false);

  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (userInfo) {
      if (userInfo) {
        setUserID(firebase.auth().currentUser.uid);
        getActivePlan(firebase.auth().currentUser.uid, function (plan) {
          setProductName(plan.name);
        });
      } else {
      }
    });
  }, []);

  useEffect(() => {
    userID && getSchedule(userID);
  }, [userID]);

  useEffect(() => {
    if (userID && onboarding) {
      setOnboarding(false);
    }
  }, [userID]);

  const getSchedule = async (userID) => {
    var tmpUnlockedPacks = {};

    var ref = await firebase
      .database()
      .ref('users/' + userID)
      .child('templatePackSchedule')
      .child('edition-1')
      .once('value');
    tmpUnlockedPacks = ref.val();

    var ref2 = await firebase
      .database()
      .ref('users/' + userID)
      .child('templatePackSchedule')
      .child('oneTime')
      .once('value');
    tmpUnlockedPacks = { ...tmpUnlockedPacks, ...ref2.val() };

    setUnlockedPacks(tmpUnlockedPacks);
  };

  const [tab, setTab] = useState(1);

  const toggleSwitch = () => setIsOn(!isOn);

  const spring = {
    type: 'spring',
    stiffness: 700,
    damping: 30,
  };

  return (
    <>
      <PageLayout
        og={'/ogs/templates.png'}
        title={'Digital Writing Templates'}
        description={
          'Browse our library of Digital Writing templates so you never have to stare at a blank page again.'
        }
      >
        <LogInModal
          isOpen={onboarding}
          setOpen={setOnboarding}
          closable={true}
        />

        <div className="mx-auto max-w-screen-xl">
          {/* <div className='border border-gray-100 bg-white p-6 rounded-xl flex flex-col space-y-4 max-w-md items-center justify-between w-full mx-auto'>
                    <div className="flex flex-col space-y-2 items-center justify-start">
                        <div className='bg-gray-100 rounded-md px-2 py-1 text-sm text-gray-500 font-semibold uppercase flex flex-row space-x-1 items-center justify-center'>
                            <LockClosedIcon className='w-4 h-4' />
                            <p>Pro Feature</p>
                        </div>
                        <p className="text-sm font-medium text-gray-700 tracking-tightish text-center">Upgrade to get access to writing templates so you never have to stare at a blank page again.</p>

                    </div>
                    <div className="relative flex items-center justify-center">
                        <div className="p-2 rounded-full bg-gradient-to-r from-blue-50 to-indigo-50 absolute animate-pulse">
                            <Button click={() => setUpgradeModalOpen(true)} size={"mini"} color={"bg-gradient-to-r from-blue-500 to-indigo-500"} prefix={<LightningBoltIcon className="w-4 h-4 -mr-2" />}>
                                Unlock Templates
                            </Button>
                        </div>
                        <Button click={() => setUpgradeModalOpen(true)} size={"mini"} color={"bg-gradient-to-r from-blue-500 to-indigo-500"} prefix={<LightningBoltIcon className="w-4 h-4 -mr-2" />}>
                            Unlock Templates
                        </Button>
                    </div>
                </div> */}

          {/*  <div className=' bg-gradient-to-r from-blue-500 to-indigo-500 rounded-b-lg fixed top-0 right-4 px-3 py-2 shadow-lg text-sm text-white font-semibold uppercase flex flex-row space-x-1 items-center justify-center'>
                    <LockClosedIcon className='w-4 h-4' />
                    <p>Pro Feature</p>
                </div> */}

          <UpgradePlanModal
            isOpen={upgradeModalOpen}
            setIsOpen={setUpgradeModalOpen}
            STRIPE_PK={STRIPE_PK}
          />

          <div className="mt-8 flex flex-col space-y-10">
            <div className="flex w-full flex-col space-y-2">
              <div className="flex flex-row items-center justify-between space-y-1">
                <h1 className="text-xl font-semibold tracking-tight text-gray-800">
                  Browse by Type
                </h1>
                {/* <Button size={"mini"} variant={"secondary"} prefix={<XIcon className={"w-4 h-4 -mr-2"} />}>Clear Filters</Button> */}
              </div>

              {/* <div className={`w-64 items-center p-2 grid grid-cols-2 relative`}>
                            <motion.div className={` h-full p-0 absolute w-1/2 z-0  ${tab === 1 ? "left-0" : "right-0"}`} layout transition={spring}>
                                <div className="bg-gray-200 h-full w-full rounded-lg " />
                            </motion.div>

                            <button onClick={() => setTab(1)} className={`z-10 font-medium text-sm tracking-tightish flex items-center justify-center space-x-1.5 ${tab === 1 ? "text-gray-800" : "text-gray-500"}`}>
                            {tab === 1 ? <EssayIconColor className={"w-6 h-6"} /> : <EssayIconSecondary className={"w-6 h-6"} /> }
                                <p>Atomic</p>
                            </button>
                            <button onClick={() => setTab(2)} className={`z-10 font-medium text-sm tracking-tightish ${tab === 2 ? "text-gray-800" : "text-gray-500"}`}>
                                Explore
                            </button>
                        </div>  */}

              {/*         <div className="h-0.5 w-full from-gray-200 bg-gradient-to-r" /> */}
              <div className="grid w-full items-center">
                {/*  <div className="h-0.5 from-gray-200 bg-gradient-to-l rounded-full col-span-2" /> */}

                <CategoriesTabs />

                {/*  <div className="h-0.5 from-gray-200 bg-gradient-to-r rounded-full col-span-2" /> */}
              </div>
            </div>

            <div className="flex w-full flex-col space-y-4">
              <h1 className="text-xl font-semibold tracking-tight text-gray-800">
                Browse Template Packs
              </h1>
              {/*         <div className="h-0.5 w-full from-gray-200 bg-gradient-to-r" /> */}

              <div className=" space-y-8">
                {editions.map((edition, index) => {
                  return (
                    <>
                      <div className="flex w-full flex-col space-y-4 rounded-2xl border border-gray-200 border-opacity-50 bg-gray-100 p-6">
                        <div className="flex flex-row items-center justify-between">
                          <div className="flex flex-col space-y-0">
                            <h1 className="text-lg font-semibold tracking-tight">
                              {edition.edition.title}
                            </h1>
                            <p className="text-sm text-gray-500">
                              {edition.edition.description}
                            </p>
                          </div>

                          <div className="hidden sm:flex">
                            {edition.edition.slug === 'edition-1' ? (
                              proPlans.includes(productName) ? (
                                <div className="flex flex-row items-center justify-center space-x-1 rounded-md bg-gray-200 px-2 py-1 text-sm font-semibold uppercase text-gray-500">
                                  <LightningBoltIcon className="h-4 w-4" />
                                  <p>Included with your Subscription</p>
                                </div>
                              ) : (
                                <div className="flex flex-row items-center justify-center space-x-1 rounded-md bg-gray-200 px-2 py-1 text-sm font-semibold uppercase text-gray-500">
                                  <LightningBoltIcon className="h-4 w-4" />
                                  <p>
                                    Included with a Pro or Premier Subscription
                                  </p>
                                </div>
                              )
                            ) : (
                              (edition.edition.slug === 'audience-building' ||
                                edition.edition.slug === 'creator-packs') && (
                                <div className="flex flex-row items-center justify-center space-x-1 rounded-md bg-gradient-to-r from-red-500/20 to-yellow-500/20 px-2 py-1 text-sm font-semibold uppercase">
                                  <FireIcon className="h-4 w-4 text-red-500" />
                                  <p className=" bg-gradient-to-r from-red-500 to-yellow-500 bg-clip-text text-transparent">
                                    Just released
                                  </p>
                                </div>
                              )
                            )}
                          </div>
                        </div>

                        <TemplatePacks
                          theme={
                            edition.edition.slug === 'edition-1'
                              ? 'light'
                              : 'dark'
                          }
                          openLoginModal={() => setOnboarding(true)}
                          isLoggedIn={userID}
                          STRIPE_PK={STRIPE_PK}
                          setUpgradeModalOpen={setUpgradeModalOpen}
                          packs={edition.packs}
                          unlockedPacks={unlockedPacks}
                          plan={productName}
                        />
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  );
}
